module.exports = __webpack_public_path__ + "static/media/Woody.15895500.png";